// src/pages/SFInventory.js

import React, { useState, useEffect } from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/20/solid';
import AddProductButton from "../components/SFInventory/AddProductButton";
import LocalInventoryHistoryDisplay from "../components/SFInventory/LocalInventoryHistoryDisplay";
import SelectLocationMenu from "../components/SFInventory/SelectLocationMenu";
import ProductIdInput from "../components/SFInventory/ProductIdInput";


// User table component
function UserTable({ productId, setProductId, location, setLocation, setHistoryData, historyData, fetchInventoryHistory }) {
    return (
        <div className="">
            <div className="sm:flex sm:items-end sm:gap-4 px-4 sm:px-6 lg:px-8">
                <ProductIdInput
                    productId={productId}
                    setProductId={setProductId}
                    location={location}
                    setHistoryData={setHistoryData}  // Pass setHistoryData here
                />
                <SelectLocationMenu location={location} setLocation={setLocation} />
                <AddProductButton />
            </div>
            {/* Pass historyData to display component */}
            <LocalInventoryHistoryDisplay 
                historyData={historyData} 
                refreshHistory={fetchInventoryHistory}
            />
        </div>
    );
}

// Main Inventory Component
function SFInventory() {
    const [productId, setProductId] = useState('');
    const [location, setLocation] = useState('A-1'); // Default location
    const [historyData, setHistoryData] = useState([]); // Initialize history data

    // Function to fetch inventory history
    const fetchInventoryHistory = async () => {
        try {
            const token = localStorage.getItem('jwt');
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/localinventoryaudithistory`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.ok) {
                const data = await response.json();
                setHistoryData(data);
            }
        } catch (error) {
            console.error('Error fetching inventory history:', error);
        }
    };

    // Load inventory history on component mount
    useEffect(() => {
        fetchInventoryHistory();
    }, []);

    return (
        <div className="space-y-8">
            <UserTable
                productId={productId}
                setProductId={setProductId}
                location={location}
                setLocation={setLocation}
                setHistoryData={setHistoryData} // Pass setHistoryData to UserTable
                historyData={historyData}       // Pass historyData to UserTable
                fetchInventoryHistory={fetchInventoryHistory} // Pass the fetch function
            />
        </div>
    );
}

export default SFInventory;
